import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ConnectedProps, connect } from 'react-redux';

import { Icon, PrimaryButton } from '@fluentui/react';
import { useHistory } from 'react-router-dom';
import { ReduxState } from '../../common/reducers';
import { CheckDelegationInvitationValidityQueryResponse } from '../../Services/ClientProxy/clientProxy';
import './SuccessInvitation.scss';

const mapStateToProps = (state: ReduxState) => ({
    currentLanguage: state.reduxlanguage.language,
});

export interface Props {
    invitationData: CheckDelegationInvitationValidityQueryResponse;
}
const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
const SuccessInvitation: FC<PropsFromRedux & Props> = (
    props: PropsFromRedux & Props
) => {
    const { t } = useTranslation(['resources']);
    const { invitationData } = props;
    const history = useHistory();
    const handleClick = () => {
        history.push('/');
    };

    return (
        <div className="successContent">
            <div className='center'>
                <div>
                    <div className="h-Thx">
                        <Icon
                            iconName="VerifiedBrandSolid"
                            className="ms-IconCheck"
                        />
                        <span>{t('form-components.Registration_Completed')}</span>
                    </div>
                </div>
                <br />
                <br />
                <div className="content">
                    <div className="thxStyle">
                        <p>
                            {t('form-components.ThxMessage1')}
                            {invitationData.taxpayerNameAr}
                        </p>
                        <br />
                        <br />
                        <PrimaryButton
                            className='logIn-btn'
                            text={t('form-components.ThxMessage2')}
                            onClick={() => handleClick()}
                            iconProps={{ iconName: 'Forward' }}
                        />

                    </div>
                </div>
            </div>
        </div>
    );
};

export default connector(SuccessInvitation);
